import Link from 'next/link';
import {
  TestimonialCode,
  TestimonialGoogleStaticURLCode,
} from './codeHighlights/TestimonialCode';

const Testimonial = () => {
  return (
    <>
      <h1>Testimonial</h1>
      <p className="lead">
        Testimonials nutzt die Google Schrift Spectral im kursiven
        Schriftschnitt. Weitere Informationen zur Schrift Spectral Italic 200
        sind auf{' '}
        <Link
          href="https://fonts.google.com/specimen/Spectral?query=spectral"
          legacyBehavior
        >
          <a target="_blank">Google Font Spectral</a>
        </Link>{' '}
        auffindbar.
      </p>

      <div className="blockquote row mt-5">
        <div className="col-9 col-md-4 mb-4 mb-md-0">
          <img
            src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/portrait.jpg`}
            className="img-fluid float-start w-100"
            alt="Quote - Barbara Muster"
            width={292}
            height={164}
          />
        </div>
        <div className="col-12 col-md-8">
          <p className="quote">
            «Das ist ein Testimonial – ein hervorgehobenes Zitat zur Bewerbung
            eines Angebots.»
          </p>
          <p className="author">Barbara Muster</p>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-12">
          <TestimonialCode />
        </div>
        <div className="col-12 mt-5">
          <h2>Spectral Schriftschnitte</h2>
          <p>
            Anschauungsbeispiel mit <i>Internationalisierung</i> der Schrift{' '}
            <code>Spectral</code> mit direkter Bezugsquelle von{' '}
            <code>Gstatic</code>. Die Schriftschnitte sind im FHNW-CSS
            integriert.
          </p>
          <TestimonialGoogleStaticURLCode />
        </div>
      </div>
    </>
  );
};

export default Testimonial;
